var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.params.value)?_c('v-btn',{attrs:{"icon":"","href":this.params.value,"target":"_blank"}},[_c('v-icon',{attrs:{"size":"12","color":"primary"}},[_vm._v("perm_media")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }